import { render, staticRenderFns } from "./productdetails.vue?vue&type=template&id=5a73540f&scoped=true&"
import script from "./productdetails.vue?vue&type=script&lang=js&"
export * from "./productdetails.vue?vue&type=script&lang=js&"
import style0 from "./productdetails.vue?vue&type=style&index=0&id=5a73540f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73540f",
  null
  
)

export default component.exports